module.exports = {
  bundle: '/bundle/',
  configure: '/configure/',
  configureSkus: '/configure-skus/',
  cart: '/cart/',
  checkout: '/checkout/',
  payment: '/checkout/payment/',
  confirmation: '/confirmation/',
  noReservation: '/no-reservation/',
  termsAndConditions: '/terms-and-conditions',
  invitationExpired: '/invitation-expired/',
};
